import Default from "./WarningIcon";
export * from "./WarningIcon";

export default Default;
